export default {
	headers: {
		financialFiles: 'Financial File',
		user: 'User',
		change: 'Change',
		changeType: 'Change Type',
		date: 'Date',
		description: 'Description'
	},
	label: {
		logType: 'Log Type',
		user: 'User',
		fromDate: 'From Date',
		toDate: 'To Date'
	},

	accounts: 'Accounts',
	accounting: 'Accounting',
	currencies: 'Currencies',
	'financial-file': 'Financial File',
	'fund-flow': 'Fund Flow',
	manufacturing: 'Manufacturing',
	'material-flow': 'Material Flow',
	'material-warehouse': 'Material Warehouse',
	users: 'Users',


	fetch: 'Fetch',
	create: 'Create',
	update: 'Update',
	delete: 'Delete',

	search: 'Search'
}